import React, { useState, useEffect } from 'react'
import Classes from './Appointments.module.css'
import RecordTable from '../Dashboard/Comp/RecordTable/RecordTable';
export default function Appointments() {

    return (
        <div className={Classes.hero}>
            <div className={Classes.header}>
                <div>
                    <h3 className={Classes.title3} >Appointments</h3>
                    <h5 className={Classes.text} >Manage all of your appointments.</h5>
                </div>
                <div>
                    <div className={Classes.searcCon}>
                        <img src="/assets/images/search.png" alt="icon" />
                        <input type="text" placeholder="Search..." />
                    </div>
                </div>
            </div>

            <RecordTable />
        </div>
    )
}
